export default class DocumentUtils {
    static getDocumentHeight() {
        const body = document.body;
        const html = document.documentElement;
        if (html) {
            return Math.max(body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        }
        else {
            return body.offsetHeight;
        }
    }
}
//# sourceMappingURL=DocumentUtils.js.map